
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import axios from 'axios'
import RoomList from '@/components/RoomList.vue'
import HeatingTypes from '@/components/HeatingTypes.vue'
import ControllerSelection from '@/components/ControllerSelection.vue'
import HelperTooltip from '@/components/HelperTooltip.vue'

export default Vue.extend({
  components: {
    RoomList,
    HeatingTypes,
    ControllerSelection,
    HelperTooltip
  },

  data: () => ({
    fetching: false,
    tableEmptyError: ''
  }),

  computed: {
    ...mapFields([
      'roomsData',
      'projectData.projectTitle',
      'projectData.rules',
      'formValidity.projectForm',
      'formValidity.roomsForm'
    ])
  },

  methods: {
    generate () {
      const quoteData = this.$store.getters.getAllDataAsJson

      const projectFormValid = (this as any).$refs.projectFormRef.validate()//eslint-disable-line
      const roomTableValid = this.validateRoomsData()
      if (!projectFormValid || !roomTableValid) { //eslint-disable-line
        ((this as any).$refs.projectFormRef.$el as HTMLElement).scrollIntoView()  // eslint-disable-line
        return
      }

      this.fetching = true

      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?generate', quoteData)
        .then(response => {
          this.$emit('moveToNext')
          this.$store.commit('setQuote', response.data)
        })
        .catch(error => console.log(error))
        .finally(() => { this.fetching = false })
    },

    validateRoomsData (): boolean {
      this.tableEmptyError = ''

      const bTableEmpty = (this as any).roomsData.length === 0 //eslint-disable-line

      if (bTableEmpty) {
        this.tableEmptyError = 'Legalább egy helyiség megadása kötelező!'
      }

      return !bTableEmpty
    }
  },

  watch: {
    roomsData (newVal) {
      if (newVal.length > 0) {
        this.tableEmptyError = ''
      }
    }
  }
})
